<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="saveNuorder()" type="button" class="btn btn-primary">Save</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";
    import addCommonSettings from "./common-settings.js";

    export default {
        name: "nuorder-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [getNestedProperty, addCommonSettings],
        props: ['channelvalues', 'channeloptions'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false
            };
        },
        methods: {
            saveNuorder: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
            },
            setItems: function () {
                var cvs = this.channelvalues;
                var cfo = this.channeloptions;
                this.channel.items = [
                    {
                        groupingName : "Settings",
                        groupItems : [
                            {
                                name : "nuorder_style_number",
                                label : "Style Number",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_style_number')) ? cvs.json_options.configuration.nuorder_style_number  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_season",
                                label : "Season",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_season')) ? cvs.json_options.configuration.nuorder_season  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_color",
                                label : "Color",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_color')) ? cvs.json_options.configuration.nuorder_color  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_brand_id",
                                label : "Brand ID",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_brand_id')) ? cvs.json_options.configuration.nuorder_brand_id  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_schema_id",
                                label : "Schema ID",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_schema_id')) ? cvs.json_options.configuration.nuorder_schema_id  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_seasons",
                                label : "Seasons",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_seasons')) ? cvs.json_options.configuration.nuorder_seasons  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_category",
                                label : "Category",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_category')) ? cvs.json_options.configuration.nuorder_category  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_subcategory",
                                label : "SubCategory",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_subcategory')) ? cvs.json_options.configuration.nuorder_subcategory  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_department",
                                label : "Department",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_department')) ? cvs.json_options.configuration.nuorder_department  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_fabric_content",
                                label : "Fabric Content",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_fabric_content')) ? cvs.json_options.configuration.nuorder_fabric_content  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_specs",
                                label : "Specs",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_specs')) ? cvs.json_options.configuration.nuorder_specs  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_us_country_manufacture",
                                label : "US Country Manufacture",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_us_country_manufacture')) ? cvs.json_options.configuration.nuorder_us_country_manufacture  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_code_color",
                                label : "Code Color",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_code_color')) ? cvs.json_options.configuration.nuorder_code_color  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_wash_code",
                                label : "Wash Code",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_wash_code')) ? cvs.json_options.configuration.nuorder_wash_code  : "",
                                options : (cfo.attributeSelectValues) ? cfo.attributeSelectValues : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "nuorder_currency",
                                label : "Currency",
                                required : true,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'nuorder_currency')) ? cvs.json_options.configuration.nuorder_currency  : null,
                                tooltip: '',
                                tooltip_position: 'top'
                            }
                        ]
                    }
                ];
            }
        },
        mounted() {
            this.setItems();
            this.channel.items = this.addCommonSettings(this.channel.items, this.channelvalues, this.channeloptions);
        },
    };
</script>